import React from 'react'

import PropTypes from 'prop-types'
import classNames from 'classnames'

import FormControl from './FormControl'

export default class FileUploadInput extends FormControl {
  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    helpText: PropTypes.string,
    disabled: PropTypes.bool,
    initialValue: PropTypes.string,
    validationFuncs: PropTypes.array,
    onFileChange: PropTypes.func
  }

  static defaultProps = {
    disabled: false,
    validationFuncs: [],
    initialValue: ''
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.initialValue !== nextProps.initialValue) {
      if (typeof this.props.onChange !== 'undefined') {
        this.props.onChange(this.props.id, nextProps.initialValue)
      }

      this.setState({
        fileName: nextProps.initialValue
      })
    }

    if (nextProps.revalidate) {
      this.validate()
    }
  }

  handleChange = e => {
    this.props.onFileChange(e)
  }

  getChangeValue() {
    return this.state.value
  }

  getValue() {
    return this.state.value
  }

  onFileSelect = e => {
    e.persist()

    let file = e.target.files[0]
    let fileReader = new FileReader()
    fileReader.onload = event =>
      this.setState({
        value: {
          size: file.size,
          name: file.name,
          type: file.type,
          fileDataUrl: event.target.result,
          fileBlob: file.preview,
          file
        }
      })
    fileReader.readAsDataURL(file)
    setTimeout(() => {
      this.handleChange(e)
      this.validate()
    }, 250)
  }

  render() {
    const { id, label, labelClass, placeholder, disabled, helpText, format } = this.props
    const groupClass = classNames({
      'form-group': !this.props.isGroup ? this.props.isGroup : true,
      'has-danger': !this.state.isValid
    })

    const labelClassName = classNames({
      'margin-bottom-0-5': true,
      [labelClass]: !!labelClass
    })

    return (
      <fieldset className={groupClass} id={id}>
        {label && (
          <label className={labelClassName} htmlFor={id}>
            {label}
          </label>
        )}
        <div>
          <input type="file" accept={format} id={id} placeholder={placeholder} disabled={disabled} onChange={this.onFileSelect} />
        </div>
        {helpText && <small className="text-muted">{helpText}</small>}
        {this.state.errorMessage && <small className="text-danger">{this.state.errorMessage}</small>}
      </fieldset>
    )
  }
}



// WEBPACK FOOTER //
// src/components/UI/FileUploadInput.jsx